import { useEffect } from "react";
import { Card, CardBody, Table } from "reactstrap";
import Moment from 'react-moment';

import { useAppDispatch, useAppSelector } from 'hooks/hooks';
import { getReturns } from "services/return.service";
import { setGetMethod } from "reducers/dto.slice";

import { DEMO_EMAIL } from "appConstants";
import DataFilters from "components/shared/DataFilters";
import Paging from "components/shared/Paging";
import DownloadPdf from "components/shared/DownloadPdf";
import TableEmptyState from "components/shared/TableEmptyState";
import { setDemoReturn } from "../reducers/return.slice";

const Returns = () => {
    const customer = useAppSelector(x => x.customers.selectedCustomer);
    const returnsDto = useAppSelector(x => x.returns.returnsDto);
    const searchDto = useAppSelector(x => x.dtos.searchTransactionDto);
    const returnsLoading = useAppSelector(x => x.returns.loading);
    const returnsError = useAppSelector(x => x.returns.error);

    const dispatch = useAppDispatch();
    
    useEffect(() => {
        if (customer?.email === DEMO_EMAIL) {
            dispatch(setDemoReturn());
        } else {
            dispatch(setGetMethod(getReturns));
            dispatch(getReturns(searchDto));
        }
    },
        [customer, dispatch, searchDto]);

    return (
        <Card className="shadow">
            <DataFilters />
            <CardBody>
                <Table bordered striped responsive className="bcd-data-table">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Purchase Order</th>
                            <th>RMA</th>
                            <th>Credit Memo</th>
                            <th>Serial Numbers</th>
                            <th>Ship Date</th>
                            <th>Shipper</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {returnsDto.items.length > 0 ?
                            returnsDto.items.map(o => {
                                return (<tr key={o.transactionId}>
                                    <td width="10%">
                                        <Moment format="MM/DD/YYYY">
                                            {o.transactionDate}
                                        </Moment>
                                    </td>
                                    <td width="15%">
                                        <DownloadPdf model={{ fileId: o.purchaseOrder || "", fileName: o.purchaseOrder || "", recordType: "purchaseOrder" }} />
                                    </td>
                                    <td width="10%">
                                        <DownloadPdf model={{ fileId: o.transactionId?.toString() || "", fileName: o.rmaNumber || "", recordType: "return" }} />
                                    </td>
                                    <td width="10%">
                                        {o.creditMemo &&
                                            <DownloadPdf model={{ fileId: o.creditMemoId?.toString() || "", fileName: o.creditMemo || "", recordType: "creditMemo" }} />
                                        }
                                    </td>
                                    <td width="15%">{o.serialNumbers}</td>
                                    <td width="10%">
                                        {o.shipDate &&
                                            <Moment format="MM/DD/YYYY">
                                                {o.shipDate}
                                            </Moment>}
                                    </td>
                                    <td>{o.shipper}</td>
                                    <td width="15%">{o.status}</td>
                                </tr>);
                            })
                            :
                            <TableEmptyState colSpan={8} isLoading={returnsLoading} error={returnsError} entityName="Returns" />
                        }
                    </tbody>
                </Table>
                <Paging />
            </CardBody>
        </Card>
    );
}

export default Returns;